import { liteClient as algoliasearch } from 'algoliasearch/lite';

export const useAlgoliaSearchClient = () => {
  const {
    public: { algoliaSearchKey, algoliaAppId }
  } = useRuntimeConfig();

  return algoliasearch(algoliaAppId, algoliaSearchKey);
};
